module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, _vm._l((_vm.cItems), function(item, index) {
    return _c('div', {
      key: item.key,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined)),
      attrs: {
        "accessible": true,
        "aria-label": ((item.title) + "," + (item.desc?item.desc:'') + "," + (item.date?item.date:'') + "," + (item.highlight?'已完成':'等待完成'))
      }
    }, [_c('div', {
      staticClass: "title flex-row",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_c('div', {
      staticClass: "line",
      class: item.__titleLineClass__,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(item.__lineStyle__))
    }), _vm._v(" "), _c('div', {
      staticClass: "point",
      class: item.__pointClass__,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(item.__pointStyle__))
    }), _vm._v(" "), _c('text', {
      staticClass: "text-title full-rest",
      class: item.__titleTextClass__,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(item.__titleStyle__))
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "content flex-row",
      class: item.__contentClass__,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_c('div', {
      staticClass: "line",
      class: item.__contentLineClass__,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(item.__lineStyle__))
    }), _vm._v(" "), _c('div', {
      staticClass: "full-rest",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [(item.desc) ? _c('text', {
      staticClass: "text-desc",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_vm._v(_vm._s(item.desc))]) : _vm._e(), _vm._v(" "), (item.date) ? _c('text', {
      staticClass: "text-date",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_vm._v(_vm._s(item.date))]) : _vm._e()])])])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61efacbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61efacbc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-simple-flow/index.vue
// module id = 190
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28